<form [formGroup]="apiConfigurationRequestForm" class="form">
    <div class="form-container" [ngClass]="{ readonly: apiConfigurationState.$mode() === FormMode.Reading }">
        <div class="form-item">
            <mat-form-field>
                <mat-label>Verbe</mat-label>
                <mat-select formControlName="httpVerb" tabindex="1">
                    @for (httpVerb of httpVerbs | keyvalue; track httpVerb.key) {
                        <mat-option [value]="httpVerb.key">
                            {{ httpVerb.value }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        <div
            class="form-item"
            [class.hidden]="
                context.apiConfigurationContext.restApiConfiguration.contextOfUse === ContextOfUse.AutocompletionDatasource ||
                apiConfigurationRequestForm.get('httpVerb')?.value === HttpVerb.Get
            ">
            <mat-form-field>
                <mat-label>Format</mat-label>
                <mat-select formControlName="requestFormat" tabindex="2">
                    @for (requestFormatType of requestFormatTypes | keyvalue; track requestFormatType.key) {
                        <mat-option [value]="requestFormatType.key">
                            {{ requestFormatType.value }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>

        <div class="form-item">
            <mat-form-field>
                <mat-label>Url</mat-label>
                <textarea
                    matInput
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="3"
                    cdkAutosizeMaxRows="5"
                    type="text"
                    formControlName="url"
                    autocomplete="off"
                    tabindex="3"
                    appNoFocusContextMenu
                    (contextmenu)="$event.preventDefault(); onInputRightClick('url', $event)"></textarea>
            </mat-form-field>
        </div>

        <div
            class="form-item"
            [class.hidden]="
                context.apiConfigurationContext.restApiConfiguration.contextOfUse === ContextOfUse.AutocompletionDatasource ||
                apiConfigurationRequestForm.get('httpVerb')?.value === HttpVerb.Get
            ">
            <mat-form-field>
                <mat-label>Contenu (corps de la requête)</mat-label>
                <textarea
                    matInput
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="5"
                    cdkAutosizeMaxRows="10"
                    formControlName="requestContent"
                    autocomplete="off"
                    tabindex="4"
                    appNoFocusContextMenu
                    (contextmenu)="$event.preventDefault(); onInputRightClick('requestContent', $event)"></textarea>
            </mat-form-field>
        </div>

        <div class="form-item">
            <mat-form-field>
                <mat-label>Authentification</mat-label>
                <mat-select formControlName="authentication" tabindex="5">
                    @for (authenticationType of authenticationTypes | keyvalue; track authenticationType.key) {
                        <mat-option [value]="authenticationType.key">
                            {{ authenticationType.value }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
            @if (apiConfigurationRequestForm.get('authentication')?.value === 'Basic') {
                <div class="form-item">
                    <mat-form-field>
                        <mat-label>Identifiant</mat-label>
                        <input matInput type="text" formControlName="username" autocomplete="off" />
                    </mat-form-field>
                </div>
                <div class="form-item">
                    <mat-form-field>
                        <mat-label>Mot de passe</mat-label>
                        <input matInput type="password" formControlName="password" autocomplete="off" />
                    </mat-form-field>
                </div>
            }
            @if (apiConfigurationRequestForm.get('authentication')?.value === 'Bearer') {
                <div class="form-item">
                    <mat-form-field>
                        <mat-label>Bearer token</mat-label>
                        <input matInput type="text" formControlName="bearer" autocomplete="off" />
                    </mat-form-field>
                </div>
            }
            @if (apiConfigurationRequestForm.get('authentication')?.value === 'ApiKey') {
                <div class="form-item">
                    <mat-form-field>
                        <mat-label>API key</mat-label>
                        <input matInput type="text" formControlName="apiKey" autocomplete="off" />
                    </mat-form-field>
                </div>
            }
        </div>
        <div class="form-table">
            <mat-form-field>
                <mat-label>Headers</mat-label>
                <app-headers-form formControlName="headers" [variableContextMenuItems]="apiConfigurationState.variableContextMenuItems" />
            </mat-form-field>
        </div>
    </div>
</form>

<div class="wizard-step-buttons">
    @if (apiConfigurationState.$mode() !== FormMode.Reading) {
        <button mat-raised-button (click)="onCancelClick()">Annuler</button>
        <button
            mat-raised-button
            class="accent-button"
            [disabled]="apiConfigurationRequestForm.invalid"
            [ngClass]="{ disabled: apiConfigurationRequestForm.invalid }"
            (click)="onSaveClick()">
            Enregistrer
        </button>
    }
</div>

<app-multi-level-context-menu
    [isRootNode]="true"
    [nodeData]="apiConfigurationState.variableContextMenuItems"
    (onContextMenuItemClick)="handleMenuItemClick($event)"
    (onClosed)="CloseContextMenu()"></app-multi-level-context-menu>
